const DISPLAY_BY_STATE = Object.freeze({
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  PACKED: 'Packed',
  READY_FOR_DISPATCH: 'Ready for Dispatch',
  CANCELLED: 'Cancelled',
});

const NEXT_BY_STATE = Object.freeze({
  PENDING: 'Processing',
  PROCESSING: 'Packed',
  PACKED: 'Ready for Dispatch',
});

export function getSellerFulfillmentDisplay(value) {
  return DISPLAY_BY_STATE[String(value || '').trim().toUpperCase()] || null;
}

export function getSellerFulfillmentOptions(order) {
  const state = String(order?.sellerFulfillmentStatus || '').trim().toUpperCase();
  const physicalState = String(order?.shipmentStatus || '').trim().toUpperCase();
  if (physicalState && !['PENDING', 'READY_FOR_DISPATCH'].includes(physicalState)) {
    return [String(order?.status || 'Pending')];
  }
  const current = getSellerFulfillmentDisplay(state) || String(order?.status || 'Pending');
  const options = [current];
  const next = NEXT_BY_STATE[state];
  if (next && !options.includes(next)) options.push(next);
  if (['PENDING', 'PROCESSING', 'PACKED', 'READY_FOR_DISPATCH'].includes(state)
    && !options.includes('Cancelled')) options.push('Cancelled');
  return options;
}

export function getSellerFulfillmentCommand(status) {
  switch (String(status || '').trim().toUpperCase().replaceAll(' ', '_')) {
    case 'PROCESSING': return 'start-processing';
    case 'PACKED': return 'mark-packed';
    case 'READY_FOR_DISPATCH': return 'ready-for-dispatch';
    case 'CANCELLED': return 'cancel-before-pickup';
    default: return null;
  }
}
